import React from 'react';
import styled from 'styled-components';
import { useChat } from '../../contexts/ChatProvider';

export const Content = styled.div`
  text-align: left;
  vertical-align: text-top;
  font-size: 14px;
  align-self: flex-start;
  line-height: auto;
  color: ${({ color }) => color || '#000000'};
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
  position: relative;
  box-sizing: border-box;
  word-wrap: break-word;
  width: 100%;
  max-width: 272px;

  a {
      color: ${({ linkColor }) => linkColor || 'blue'};
  }
  .div1 {
    width: 100%;
  }
  .pre1 {
    background-color: ${({ theme }) => theme || '#FFF'};
    border-radius: 5px;
    padding: 5px;
    overflow-x: auto; 
    overflow-y: hidden;
    max-width: 100%;
  }
  .code1 {
    font-size: 12px;
    display: block;
    text-align: left;
  }
  .singleBackTick {
    background-color: ${({ theme }) => theme || '#FFF'};
    font-size: 12px;
    display: inline;
    text-align: left;
    border-radius: 5px;
    padding: 5px;
  }
  @media only screen and (min-width: 768px) {
    .pre1 {
      width: auto;
      max-width: 230px; 
    }
  }
  @media only screen and (max-width: 360px) {
    .pre1 {
      width: auto;
      max-width: 202px; 
    }
  }
    
`;


export default function TextContent({ linkColor, color, children = '' }) {
  const { theme } = useChat();
  const formatText = (text) => {
    text = text.replace(/```(json|javascript)?\n([\s\S]+?)```/g, (match, lang, code) => {
      return `<div class="div1"><pre class="pre1"><code class="code1">${code.trim()}</code></pre></div>`;
    });
    text = text.replace(/`([^`]+)`/g, (match, code) => {
      return `<code class="singleBackTick">${code.trim()}</code>`;
    });
    // Replace headers with <h3> tags
    text = text.replace(/### (.+?)(?=\n|$)/g, '<h3>$1</h3>');

    // Replace list items with <li> tags inside a <ul>
    text = text.replace(/- (.+?)(?=\n|$)/g, '<li style="list-style:disc;">$1</li>');
    text = text.replace(/(<li>.+<\/li>)/g, '<ul >$1</ul>');
    
    // Replace bold text with <strong> tags
    text = text.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');

    // Replace image with <img> tag
    text = text.replace(/!\[(.+?)\]\((.+?)\)/g, '<img alt="$1" src="$2" height="160" width="160" />');

    // Replace links with <a> tags
    text = text.replace(/\[(.+?)\]\((.+?)\)/g, '<a href="$2" target="_blank">$1</a>');

    // Replace newlines with <br> tags
    text = text.replace(/\n/g, '<br />');

    return text;
  };
  
  // console.log("message = ", children)
  // console.log("formattedText = ", formattedText)
  return (
     <Content
          linkColor={linkColor}
          color={color}
          theme={theme}
          dangerouslySetInnerHTML={{ 
            __html: formatText(children)
         }}
      />
  );
}
